<template>
  <el-form :model="filters" size="mini" label-position="top">
    <b-form-row>
      <div class="col-md-4">
        <el-form-item label="Nome:" label-for="nome">
          <b-form-input
            size="sm"
            id="nome"
            v-model="filters.nome"
            placeholder="Nome do Centro de Custo"
          />
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-4">
        <el-form-item label="Apelido:" label-for="apelido">
          <b-form-input
            size="sm"
            id="apelido"
            v-model="filters.apelido"
            placeholder="Apelido"
          />
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-4">
        <el-form-item label="Grupo:" label-for="grupo">
          <b-form-input
            size="sm"
            id="grupo"
            v-model="filters.grupo"
            placeholder="Grupo"
          />
        </el-form-item>
      </div>
    </b-form-row>
  </el-form>
</template>

<script>
export default {
  name: 'CentrosCustosFormFilters',
  props: {
    filters: {
      type: Object,
      required: false,
    }
  }
}
</script>
<style scoped>
</style>
